import React from 'react';
import { Form, FormGroup, Col, Row } from 'react-bootstrap';
import LoadingSpinner from '../../../LoadingSpinner';
import * as Convert from '../../../util/unitConversion';

class LogisticsExpander extends React.Component {
    render() {
        const data = this.props.logisticsExpander === undefined ? {} : this.props.logisticsExpander.CallOffItems; // byt ut orderStatus
        
        if (this.props.logisticsExpander === undefined)
        {
            return (<div className="height180"><LoadingSpinner isLoading={true} /> </div>);
        }
        else
        {
            return (
                <Col sm={1}>
                    <Form horizontal autoComplete="off" onSubmit={evt => { evt.preventDefault(); }} style={{ "width": "1800px" }}>
                        <FormGroup>
                            {data.map(({PRODUCT_CODE, ORDER_COMBO, BASIS_WEIGHT_UC, PLANNED_QUANTITY, PLANNED_WEIGHT_UC, ROLL_WIDTH_UC}) => (
                                <Row key={ORDER_COMBO}>
                                    <Col xs={1}>Order:  {ORDER_COMBO}</Col>
                                    <Col xs={2}>Product:  {PRODUCT_CODE}</Col>
                                    <Col xs={1}>Quantity:   {PLANNED_QUANTITY}</Col>
                                    <Col xs={1}><Convert.TextTo value_metric={"Weight (kg):"} value_imperial={"Weight (lb):"}/>    {PLANNED_WEIGHT_UC}</Col>
                                    <Col xs={1}><Convert.TextTo value_metric={"Grammage:"} value_imperial={"Basis Weight:"}/>   <Convert.AddSymbol check={BASIS_WEIGHT_UC}/>{BASIS_WEIGHT_UC}</Col>
                                    <Col xs={1}><Convert.TextTo value_metric={"Width (mm):"} value_imperial={"Width (in):"}/>    {ROLL_WIDTH_UC  === 0 ? '-' : ROLL_WIDTH_UC}</Col>
                                </Row>
                            ))}
                        </FormGroup>
                    </Form>
                </Col>
            )
        }
    }
}

export default LogisticsExpander;